import { render, staticRenderFns } from "./coperotelfirsatiaktarim.vue?vue&type=template&id=db7637b6&"
import script from "./coperotelfirsatiaktarim.vue?vue&type=script&lang=js&"
export * from "./coperotelfirsatiaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports